/**
 * Load and save featured job role slugs (Build Contract §1D).
 */

import { getSafeSupabaseClient } from './supabaseSync';
import { jobSlugsFromAssignments } from './contributorNavProfiles';

const TABLE = 'user_rich_profiles';

export async function loadFeaturedJobRoleSlugs(userId: string): Promise<string[]> {
  const client = getSafeSupabaseClient();
  if (!client || !userId || userId === 'unknown') return [];

  const { data, error } = await client
    .from(TABLE)
    .select('featured_job_role_slugs')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) {
    console.error('[featuredJobRoles] load failed:', error.message);
    return [];
  }

  const raw = data?.featured_job_role_slugs;
  return Array.isArray(raw) ? raw.filter((s): s is string => typeof s === 'string' && s.length > 0) : [];
}

export async function saveFeaturedJobRoleSlugs(
  userId: string,
  slugs: string[],
  assignedRoleNames: string[],
): Promise<{ ok: boolean; error?: string }> {
  const client = getSafeSupabaseClient();
  if (!client || !userId || userId === 'unknown') {
    return { ok: false, error: 'Not signed in' };
  }

  const assigned = new Set(jobSlugsFromAssignments(assignedRoleNames));
  const sanitized = [...new Set(slugs.filter((s) => assigned.has(s)))];
  const now = new Date().toISOString();

  const { error } = await client.from(TABLE).upsert(
    {
      user_id: userId,
      featured_job_role_slugs: sanitized,
      updated_at: now,
    },
    { onConflict: 'user_id' },
  );

  if (error) {
    console.error('[featuredJobRoles] save failed:', error.message);
    return { ok: false, error: error.message };
  }

  return { ok: true };
}
